export default {
    // BASE_URL: `https://ai-erp-backend.neuracase.com/api/v1`,
    BASE_URL: process.env.REACT_APP_SEVER_URL
}
